/*
  SST bundle builder — "Pick N prints" volume picker.
  Markup: snippets/sst-bundle-builder.liquid. One print per row, tier cards set how
  many rows are active. Print 1's size dropdown is the page's size (synced with the theme's
  Size circles); rows 2+ follow it until switched in their own dropdown. Above the rows, one
  preview composes every chosen print's product photo (renderPreview).
  Adds real variants through /cart/add.js, attaches the tier's discount code (/cart/update.js)
  so only packs built here get the pack price, then hands off to the theme's cart drawer
  via the same "ajaxProduct:added" event theme.AjaxProduct uses.
*/
(function () {
  if (customElements.get('sst-bundle-builder')) return;

  // Plain text: the store's money format wraps amounts in <span class=money> for currency apps
  function formatMoney(cents, format) {
    var out = window.theme && theme.Currency && theme.Currency.formatMoney
      ? theme.Currency.formatMoney(cents, format)
      : '$' + (cents / 100).toFixed(2);
    return String(out).replace(/<[^>]*>/g, '');
  }

  // Print titles compare without a trailing " kids" (bermies.com.ar: "Palm Stripes" ↔ "Palm Stripes Kids")
  function titleKey(title) {
    return String(title || '').toLowerCase().replace(/\s+kids\s*$/, '').trim();
  }

  // Fixed texts; headings, row labels and button texts come from block settings (data-*)
  var STRINGS = {
    en: {
      shipAddOne: 'Add 1 more {noun} for free US shipping', shipOver: 'Free US shipping over {amount}',
      shipFree: 'Free US shipping on this order',
      pctOff: '{n}% OFF',
      selectSize: 'Select a size', needSize: 'To continue, choose your size.',
      soldOut: 'Sold out', soldOutIn: 'Sold out in {size}',
      soldOutSizeMsg: '{title} is sold out in {size}. Choose another size or print above.',
      soldOutMsg: '{title} is sold out. Choose another print above.',
      pickMore: 'Pick {n} more {noun}', pickMoreMany: 'Pick {n} more {noun}s',
      needPrint: 'To continue, choose {row}.', needPrintMany: 'To continue, choose {row} ({n} {noun}s left to pick).',
      fill: 'Fill the {n} empty rows with {title}', error: 'Something went wrong. Please try again.',
      sizeLabel: 'Size', soldOutOption: '{size} (sold out)',
      bundle: 'Your bundle', youSave: 'You save ', each: 'each', save: 'Save {amount}',
      preview: 'Your bundle: {list}', kidsPreview: 'Matching sets: {list}', notChosen: '{row} not chosen yet',
      kidsFrom: 'From {price}', kidsPlus: " + {n} kids' trunk", kidsPlusMany: " + {n} kids' trunks",
      kidsChooseSize: "Choose a kids' size",
      kidsNeedSize: "To continue, choose a kids' size (or switch off the matching kids' trunk).",
      kidsNeedSizeRow: 'To continue, choose a size for {row}.', kidsRow: 'Kids {n}', kidsNoSize: 'choose a size',
      kidsRemove: 'Remove {row}',
      dadPlus: " + {n} dad's trunk", dadPlusMany: " + {n} dad's trunks", dadChooseSize: "Choose dad's size",
      dadNeedSize: "To continue, choose dad's size (or switch off the matching dad's trunk).", dadRow: 'Dad {n}',
      addonPlus: ' + {noun}', addonChooseSize: 'Choose a size',
      addonNeedSize: 'To continue, choose a size for the {item} (or switch it off).',
      instTotal: '{amount} total', instFree: 'interest-free', instMore: 'Add {n} more for {k} installments'
    },
    es: {
      shipAddOne: 'Sumá 1 {noun} más y el envío es gratis', shipOver: 'Envío gratis desde {amount}',
      shipFree: 'Envío gratis en este pedido',
      pctOff: '{n}% OFF',
      selectSize: 'Elegí un talle', needSize: 'Para continuar, elegí tu talle.',
      soldOut: 'Agotado', soldOutIn: 'Agotado en talle {size}',
      soldOutSizeMsg: '{title} está agotado en talle {size}. Elegí otro talle o estampado arriba.',
      soldOutMsg: '{title} está agotado. Elegí otro estampado arriba.',
      pickMore: 'Elegí {n} {noun} más', pickMoreMany: 'Elegí {n} {noun}s más',
      needPrint: 'Para continuar, elegí {row}.', needPrintMany: 'Para continuar, elegí {row} (faltan {n} {noun}s).',
      fill: 'Completar los {n} vacíos con {title}', error: 'Algo salió mal. Probá de nuevo.',
      sizeLabel: 'Talle', soldOutOption: '{size} (agotado)',
      bundle: 'Tu pack', youSave: 'Ahorrás ', each: 'c/u', save: 'Ahorrás {amount}',
      preview: 'Tu pack: {list}', kidsPreview: 'Sets haciendo juego: {list}', notChosen: '{row} sin elegir',
      kidsFrom: 'Desde {price}', kidsPlus: ' + {n} de chicos', kidsPlusMany: ' + {n} de chicos',
      kidsChooseSize: 'Elegí el talle de chicos',
      kidsNeedSize: 'Para continuar, elegí el talle de chicos (o apagá el short de chicos).',
      kidsNeedSizeRow: 'Para continuar, elegí el talle de {row}.', kidsRow: 'Chicos {n}', kidsNoSize: 'elegí talle',
      kidsRemove: 'Quitar {row}',
      addonPlus: ' + {noun}', addonChooseSize: 'Elegí el talle',
      addonNeedSize: 'Para continuar, elegí el talle (o apagalo).',
      dadPlus: ' + {n} de papá', dadPlusMany: ' + {n} de papá', dadChooseSize: 'Elegí el talle de papá',
      dadNeedSize: 'Para continuar, elegí el talle de papá (o apagá el short de papá).', dadRow: 'Papá {n}',
      instTotal: '{amount} total', instFree: 'sin interés', instMore: 'Sumá {n} más para {k} cuotas'
    }
  };

  // Shape of a product photo shot on a plain background: the background colour (read off the photo's edges)
  // is flood-filled in from the border and the largest shape left is the garment. Resolves to { url, box, ratio }:
  // a blob URL of an alpha mask (opaque = garment) laid over the untouched photo as a CSS mask (the photo keeps its
  // full detail), the garment's bounds in the photo (0–1) and the photo's height/width; null when the photo can't
  // be read. One run per photo.
  var shapes = {};
  function shape(url) {
    if (!shapes[url]) {
      shapes[url] = loadImage(url).then(function (img) {
        if (!img) return null;
        try {
          return makeShape(img);
        } catch (e) {
          return null;
        }
      });
    }
    return shapes[url];
  }

  // One CORS download per photo, shared by the preview's <img> (same URL, same crossorigin) and the shape
  var images = {};
  function loadImage(url) {
    if (!images[url]) {
      images[url] = new Promise(function (resolve) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { resolve(img); };
        img.onerror = function () { resolve(null); };
        img.src = url;
      });
    }
    return images[url];
  }

  function makeShape(img) {
    var scale = Math.min(1, 500 / Math.max(img.naturalWidth, img.naturalHeight));
    var w = Math.max(1, Math.round(img.naturalWidth * scale));
    var h = Math.max(1, Math.round(img.naturalHeight * scale));
    var total = w * h;
    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, w, h);
    var image = ctx.getImageData(0, 0, w, h);
    var px = image.data;

    var border = [];
    for (var x = 0; x < w; x++) border.push(x, total - w + x);
    for (var y = 0; y < h; y++) border.push(y * w, y * w + w - 1);
    var bgColor = [0, 1, 2].map(function (c) {
      var values = border.map(function (p) { return px[p * 4 + c]; }).sort(function (a, b) { return a - b; });
      return values[values.length >> 1];
    });
    // Tight tolerance: white liners sit right next to a white background
    function isBackground(p) {
      var o = p * 4;
      return px[o + 3] <= 24 || (Math.abs(px[o] - bgColor[0]) <= 6 && Math.abs(px[o + 1] - bgColor[1]) <= 6 && Math.abs(px[o + 2] - bgColor[2]) <= 6);
    }
    function neighbours(p, fn) {
      var col = p % w;
      if (col > 0) fn(p - 1);
      if (col < w - 1) fn(p + 1);
      if (p >= w) fn(p - w);
      if (p < total - w) fn(p + w);
    }

    var bg = new Uint8Array(total);
    var stack = [];
    function visit(p) {
      if (bg[p] || !isBackground(p)) return;
      bg[p] = 1;
      stack.push(p);
    }
    border.forEach(visit);
    while (stack.length) neighbours(stack.pop(), visit);

    // Keep the largest shape: specks of off-white background noise don't count as garment
    var label = new Int32Array(total);
    var best = 0;
    var bestSize = 0;
    var current = 0;
    for (var s = 0; s < total; s++) {
      if (bg[s] || label[s]) continue;
      current++;
      var size = 0;
      label[s] = current;
      stack.push(s);
      while (stack.length) {
        size++;
        neighbours(stack.pop(), function (q) {
          if (!bg[q] && !label[q]) {
            label[q] = current;
            stack.push(q);
          }
        });
      }
      if (size > bestSize) {
        bestSize = size;
        best = current;
      }
    }
    if (!best) return null;

    // Drop the outermost pixel ring (it carries the white background's tint), then one 3×3 blur so the edge
    // is anti-aliased like the photo's own (by hand: Safari ignores the canvas `filter`)
    var alpha = new Float32Array(total);
    var minX = w;
    var minY = h;
    var maxX = 0;
    var maxY = 0;
    for (var j = 0; j < total; j++) {
      if (label[j] !== best) continue;
      alpha[j] = 1;
      var jx = j % w;
      var jy = (j - jx) / w;
      if (jx < minX) minX = jx;
      if (jx > maxX) maxX = jx;
      if (jy < minY) minY = jy;
      if (jy > maxY) maxY = jy;
    }
    var box = { x: minX / w, y: minY / h, w: (maxX - minX + 1) / w, h: (maxY - minY + 1) / h };
    alpha = boxBlur(erode(alpha, w, h), w, h);
    for (var k = 0; k < total; k++) {
      px[k * 4] = px[k * 4 + 1] = px[k * 4 + 2] = 0;
      px[k * 4 + 3] = Math.round(alpha[k] * px[k * 4 + 3]);
    }
    ctx.putImageData(image, 0, 0);

    // PNG keeps the soft edge exact (a flat black mask compresses to a few KB)
    return new Promise(function (resolve) {
      var done = function (url) { resolve(url ? { url: url, box: box, ratio: h / w } : null); };
      if (!canvas.toBlob) {
        done(canvas.toDataURL('image/png'));
        return;
      }
      canvas.toBlob(function (blob) { done(blob ? URL.createObjectURL(blob) : null); }, 'image/png');
    });
  }

  // Sizes a photo inside its slot so the garment (box = its bounds in the photo, 0–1) fills the slot: centred
  // across, waistband on the slot's top edge, whatever white margin the photo has. aspect = slot width / height.
  function fitGarment(el, box, ratio, aspect) {
    var k = Math.min(1 / box.w, 1 / (aspect * box.h * ratio));
    el.style.width = k * 100 + '%';
    el.style.height = k * ratio * aspect * 100 + '%';
    el.style.left = ((1 - box.w * k) / 2 - box.x * k) * 100 + '%';
    el.style.top = -box.y * k * ratio * aspect * 100 + '%';
  }

  var WHOLE_PHOTO = { x: 0, y: 0, w: 1, h: 1 };
  // Garment box shape (width / height) the row is laid out with: the flat-lays are a little wider than tall
  var SLOT_ASPECT = 1.25;

  function withWidth(url, width) {
    return String(url || '').replace(/([?&])width=\d+/, '$1width=' + width);
  }

  function erode(src, w, h) {
    var total = w * h;
    var out = new Float32Array(total);
    for (var i = 0; i < total; i++) {
      var col = i % w;
      out[i] = src[i] && (col > 0 ? src[i - 1] : 0) && (col < w - 1 ? src[i + 1] : 0) && (i >= w ? src[i - w] : 0) && (i < total - w ? src[i + w] : 0) ? 1 : 0;
    }
    return out;
  }

  function boxBlur(src, w, h) {
    var total = w * h;
    var tmp = new Float32Array(total);
    var out = new Float32Array(total);
    for (var i = 0; i < total; i++) {
      var col = i % w;
      tmp[i] = (src[i] + (col > 0 ? src[i - 1] : src[i]) + (col < w - 1 ? src[i + 1] : src[i])) / 3;
    }
    for (var p = 0; p < total; p++) {
      out[p] = (tmp[p] + (p >= w ? tmp[p - w] : tmp[p]) + (p < total - w ? tmp[p + w] : tmp[p])) / 3;
    }
    return out;
  }

  function setMask(el, url) {
    el.style.webkitMaskImage = url ? 'url(' + url + ')' : '';
    el.style.maskImage = url ? 'url(' + url + ')' : '';
  }

  function whenIdle(fn) {
    if (window.requestIdleCallback) {
      requestIdleCallback(fn, { timeout: 3000 });
    } else {
      setTimeout(fn, 1500);
    }
  }

  class SstBundleBuilder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      var json = this.querySelector('[data-bb-json]');
      if (!json) return;
      this.data = JSON.parse(json.textContent);
      this.moneyFormat = (window.theme && theme.settings && theme.settings.moneyFormat) || this.data.moneyFormat;
      this.styles = this.data.styles.map(this.prepareStyle, this);

      this.strings = STRINGS[this.dataset.lang] || STRINGS.en;
      this.showSavings = this.dataset.showSavings === 'true';
      this.fullPriceOnly = this.dataset.fullPriceOnly === 'true';
      this.freeShipCents = parseInt(this.dataset.freeShipCents, 10) || 0;
      // Installments mode (bermies.com.ar): cards show "3 x $X" from this pack total up, no pack discounts
      this.instMin = parseInt(this.dataset.instMin, 10) || 0;
      this.instN = parseInt(this.dataset.instN, 10) || 3;
      this.size = this.dataset.size || null;
      this.qty = parseInt(this.dataset.defaultQty, 10) || 1;

      this.sizeButtons = Array.from(this.querySelectorAll('[data-bb-size]'));
      this.rows = Array.from(this.querySelectorAll('[data-bb-row]'));
      this.tiers = Array.from(this.querySelectorAll('[data-bb-tier]')).map(function (el) {
        return { el: el, qty: parseInt(el.dataset.qty, 10), pct: parseFloat(el.dataset.pct) || 0, code: (el.dataset.code || '').trim() };
      });
      // Per-row size for rows 2+; null = follow the page's size
      this.rowSizes = this.rows.map(function () { return null; });
      this.heading = this.querySelector('[data-bb-heading]');
      this.cta = this.querySelector('[data-bb-cta]');
      this.ctaText = this.querySelector('[data-bb-cta-text]');
      this.ctaCompare = this.querySelector('[data-bb-cta-compare]');
      this.ctaPrice = this.querySelector('[data-bb-cta-price]');
      this.ctaNote = this.querySelector('[data-bb-cta-note]');
      this.ctaSub = this.querySelector('[data-bb-cta-sub]');
      this.sumLabel = this.querySelector('[data-bb-sum-label]');
      this.sumSave = this.querySelector('[data-bb-sum-save]');
      this.shipNudge = this.querySelector('[data-bb-ship-nudge]');
      this.error = this.querySelector('[data-bb-error]');
      this.field = this.querySelector('[data-bb-field]');
      this.panel = this.querySelector('[data-bb-swatches]');
      this.fillBtn = this.querySelector('[data-bb-fill]');

      this.warn = this.querySelector('[data-bb-warn]');
      this.preview = this.querySelector('[data-bb-preview]');
      this.stage = this.querySelector('[data-bb-stage]') || this.preview;
      this.slots = [];
      if (this.preview && window.ResizeObserver) {
        new ResizeObserver(this.sizePreview.bind(this)).observe(this.preview);
      }

      // Complete the look: the kids' versions of the pack's prints
      var kidsJson = this.querySelector('[data-bb-kids-json]');
      this.kidsCard = this.querySelector('[data-bb-kids]');
      this.kids = kidsJson && this.kidsCard ? JSON.parse(kidsJson.textContent).map(this.prepareStyle, this) : [];
      if (this.kidsCard) {
        this.kidsSwitch = this.kidsCard.querySelector('[data-bb-kids-switch]');
        this.kidsBody = this.kidsCard.querySelector('[data-bb-kids-body]');
        this.kidsPrice = this.kidsCard.querySelector('[data-bb-kids-price]');
        this.kidsPrints = this.kidsCard.querySelector('[data-bb-kids-prints]');
        this.kidsSizes = this.kidsCard.querySelector('[data-bb-kids-sizes]');
        // A switch: off (default) = not interested; on = the kids' trunk goes in with the pack
        this.kidsOn = false;
        this.kidsMore = this.kidsCard.querySelector('[data-bb-kids-more]');
        this.kidsDad = this.kidsCard.hasAttribute('data-bb-kids-dad');
        this.kidsPreview = this.kidsCard.querySelector('[data-bb-kids-preview]');
        // Two set tiles: the big one in the open card, a mini one in the header's picture spot while it's off
        this.kidsTile = this.makeTile(this.kidsPreview, '[data-bb-kids-stage]', 'bbKidsSlot', 220);
        this.kidsMiniTile = this.makeTile(this.kidsCard.querySelector('[data-bb-kids-mini]'), '[data-bb-kids-mini-stage]', 'bbKidsMini', 400, true);
        this.kidsList = this.kidsCard.querySelector('[data-bb-kids-list]');
        // One entry per kids' trunk (print + size); the print circles and sizes edit kidsItems[kidsEdit]
        this.kidsItems = [{ pick: null, size: null }];
        this.kidsEdit = 0;
      }

      // Complete the look: one full-price product from the other category (only when there's no kids' card).
      // addonPick = the chosen size's variant { id, price }; it counts once the switch is on and a size is picked
      this.addonCard = this.querySelector('[data-bb-addon]');
      if (this.addonCard) {
        this.addonSwitch = this.addonCard.querySelector('[data-bb-addon-switch]');
        this.addonBody = this.addonCard.querySelector('[data-bb-addon-body]');
        this.addonSizes = this.addonCard.querySelector('[data-bb-addon-sizes]');
        this.addonOn = false;
        this.addonPick = null;
      }

      // Size comes from the theme's own Variant picker block when it's on the page (keeps its circles + Size guide)
      var scope = this.closest('.shopify-section') || document;
      var optionKey = 'option' + ((this.data.sizeIndex || 0) + 1);
      this.themeSizeInputs = Array.from(scope.querySelectorAll('[data-variant-input][data-index="' + optionKey + '"]'));
      if (this.themeSizeInputs.length) {
        var checked = this.themeSizeInputs.find(function (input) { return input.checked; });
        if (checked) this.size = checked.value;
        this.themeSizeInputs.forEach(function (input) {
          input.addEventListener('change', function () {
            if (input.checked) this.setSize(input.value);
          }.bind(this));
        }, this);
      } else if (this.sizeButtons.length) {
        this.querySelector('[data-bb-sizes]').hidden = false;
      } else {
        // Products without a size option: the single option value is the "size"
        this.size = '__any__';
      }

      // Print 1 is the print of the page being viewed; the shopper picks prints 2+ (their size starts on Print 1's)
      var currentIndex = this.styles.findIndex(function (s) {
        return s.id === this.data.currentId;
      }, this);
      this.currentIndex = currentIndex;
      this.picks = this.rows.map(function (_, i) {
        return i === 0 && currentIndex > -1 ? currentIndex : null;
      });

      // With the Prints circles at the top of the page, Print 1 is this page's print: change it up there
      this.topPrints = scope.querySelector('.product-list-wrapper .js-sst-matching-swatch') ? scope.querySelector('.product-list-wrapper') : null;
      this.lockFirst = !!this.topPrints && currentIndex > -1;

      // This page's print sold out in the starting size (or entirely): don't count it as Print 1
      if (this.picks[0] != null && !this.styleAvailable(this.styles[this.picks[0]])) this.picks[0] = null;

      // Only one row shows its swatches at a time; finished rows collapse to their pick
      this.openRow = null;

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      // A finger on a print starts its photo and shape before the tap completes
      this.addEventListener('pointerdown', function (evt) {
        var swatch = evt.target.closest('[data-bb-style]');
        var style = swatch && this.styles[parseInt(swatch.dataset.bbStyle, 10)];
        if (style && style.image) shape(style.image);
      }.bind(this));
      this.bindStickyBar();
      this.render();
      this.stickToBottom();

      // This page's trunk is Print 1 of every pack: have its photo and shape ready before Buy 2 is tapped
      var current = this.currentStyle();
      if (this.preview && current && current.image) {
        whenIdle(function () { shape(current.image); });
      }
    }

    // Opening the prints downloads their photos one at a time in the background, so a tapped print shows
    // straight away (only on fast connections without Save-Data: the photos are 1000px)
    warmPrints() {
      if (this.warmed) return;
      this.warmed = true;
      var connection = navigator.connection || {};
      if (connection.saveData || /2g|3g/.test(connection.effectiveType || '')) return;
      var urls = Array.from(this.panel.querySelectorAll('[data-bb-style]:not([hidden])')).map(function (swatch) {
        var style = this.styles[parseInt(swatch.dataset.bbStyle, 10)];
        return style && style.image;
      }, this).filter(Boolean);
      var next = function () {
        if (urls.length) loadImage(urls.shift()).then(next);
      };
      whenIdle(next);
    }

    prepareStyle(style) {
      var sizeIndex = style.options.findIndex(function (name) {
        return /size|talle|tama/i.test(name);
      });
      style.sizeIndex = sizeIndex > -1 ? sizeIndex : this.data.sizeIndex || 0;
      return style;
    }

    variantFor(style, size) {
      if (size === '__any__') {
        return style.variants.find(function (v) { return v.available; }) || null;
      }
      return style.variants.find(function (v) {
        return v.available && v.options[style.sizeIndex] === size;
      }) || null;
    }

    styleAvailable(style, size) {
      if (size === undefined) size = this.size;
      if (!size) {
        return style.variants.some(function (v) { return v.available; });
      }
      return !!this.variantFor(style, size);
    }

    sizeFor(index) {
      return (index > 0 && this.rowSizes[index]) || this.size;
    }

    sizesOf(style) {
      var seen = [];
      style.variants.forEach(function (v) {
        var value = v.options[style.sizeIndex];
        if (seen.indexOf(value) < 0) seen.push(value);
      });
      return seen;
    }

    activeTier() {
      var qty = this.qty;
      return this.tiers.find(function (t) { return t.qty === qty; }) || { qty: qty, pct: 0 };
    }

    // Stand-in for rows not picked yet: this page's print at the chosen size
    baseVariant() {
      var current = this.styles.find(function (s) { return s.id === this.data.currentId; }, this) || this.styles[0];
      var variant = this.size ? this.variantFor(current, this.size) : null;
      return variant || current.variants.find(function (v) { return v.available; }) || current.variants[0];
    }

    rowVariant(i) {
      var pick = this.picks[i];
      var size = this.sizeFor(i);
      if (pick == null || !size) return null;
      return this.variantFor(this.styles[pick], size);
    }

    // Tier % only applies to full-price items when the discount excludes sale items
    // Shopify discounts each item and rounds that discount down to the cent ($69.99 at 10% off = $63.00)
    discounted(variant, pct) {
      if (!pct || !this.eligible(variant)) return variant.price;
      return variant.price - Math.floor(variant.price * pct / 100 + 1e-9);
    }

    // Same rule as the discounts' "price is not reduced" collection: ANY compare-at price counts as on sale
    eligible(variant) {
      return !(this.fullPriceOnly && variant.compare != null);
    }

    // Shopify's "minimum quantity" counts eligible items only: a 3-pack with one sale print gets the 2-item rate
    pctForCount(count) {
      return this.tiers.reduce(function (pct, t) { return t.qty <= count && t.pct > pct ? t.pct : pct; }, 0);
    }

    // rate = the % the pack gets (the matching kids' / dad's trunks are always full price and never count)
    // A pack of N of this page's print (what the tier cards show)
    uniformRows(qty, pct) {
      var variant = this.baseVariant();
      var rate = this.eligible(variant) ? Math.min(pct, this.pctForCount(qty)) : 0;
      var each = this.discounted(variant, rate);
      return {
        price: variant.price * qty,
        compare: Math.max(variant.compare || 0, variant.price) * qty,
        total: each * qty,
        missing: 0,
        rate: rate
      };
    }

    priceRows(qty, pct, fillMissing) {
      var sum = { price: 0, compare: 0, total: 0, missing: 0, rate: 0 };
      var variants = [];
      for (var i = 0; i < qty; i++) {
        var variant = this.rowVariant(i);
        if (!variant) {
          sum.missing++;
          if (!fillMissing) continue;
          variant = this.baseVariant();
        }
        variants.push(variant);
      }
      var eligibleCount = variants.filter(this.eligible, this).length;
      var rate = Math.min(pct, this.pctForCount(eligibleCount));
      sum.rate = rate;
      variants.forEach(function (variant) {
        sum.price += variant.price;
        sum.compare += Math.max(variant.compare || 0, variant.price);
        sum.total += this.discounted(variant, rate);
      }, this);
      return sum;
    }

    t(key, vars) {
      // Kids' pages offer dad's trunks in the same card: its texts swap to their dad versions where there are any
      if (this.kidsDad && key.indexOf('kids') === 0 && this.strings['dad' + key.slice(4)]) key = 'dad' + key.slice(4);
      return this.strings[key].replace(/\{(\w+)\}/g, function (_, name) { return vars && vars[name] != null ? vars[name] : ''; });
    }

    currentStyle() {
      return this.styles.find(function (st) { return st.id === this.data.currentId; }, this) || this.styles[0];
    }

    // The theme's sticky "Add to cart" bar (snippets/sticky-cart) only wires itself to the stock buy button,
    // which builder pages don't render: show it past the builder's button and route it through the builder.
    bindStickyBar() {
      var bar = document.getElementById('StickyCart');
      if (!bar || !window.IntersectionObserver) return;
      this.stickyBar = bar;
      this.stickyText = bar.querySelector('[data-add-to-cart-text]');
      this.stickySelect = bar.querySelector('.sticky-cart-select');
      this.stickyTitle = bar.querySelector('.sticky-cart-title');
      this.stickyTitleText = this.stickyTitle ? this.stickyTitle.textContent.trim() : '';
      var stickyTextBox = bar.querySelector('.sticky-cart-text');
      if (stickyTextBox) {
        bar.classList.add('sst-bb-sticky');
        this.stickyPrice = document.createElement('div');
        this.stickyPrice.className = 'sst-bb-sticky__price';
        this.stickyPrice.innerHTML = '<span class="sst-bb-sticky__total"></span><s class="sst-bb-sticky__compare"></s><span class="sst-bb-sticky__save"></span>';
        stickyTextBox.appendChild(this.stickyPrice);
      }

      // Shown whenever the pack's own button is off screen, so an Add to cart is always in view
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }).observe(this.cta);

      var submit = bar.querySelector('[data-sticky-add-to-cart]');
      if (submit) {
        submit.addEventListener('click', function () {
          if (this.cta.getAttribute('aria-disabled') === 'true') {
            this.showMissing();
          } else {
            this.addToCart();
          }
        }.bind(this));
      }

      if (this.stickySelect) {
        this.stickySelect.addEventListener('change', function () {
          var current = this.currentStyle();
          var variant = current.variants.find(function (v) { return String(v.id) === this.stickySelect.value; }, this);
          if (!variant) return;
          var size = variant.options[current.sizeIndex];
          var radio = this.themeSizeInputs.find(function (input) { return input.value === size; });
          if (radio) {
            radio.click();
          } else {
            this.setSize(size);
          }
        }.bind(this));
      }
    }

    syncStickyBar() {
      if (this.stickyText) this.stickyText.textContent = this.ctaText.textContent;
      if (this.stickyPrice && this.summary) {
        var kidsCount = this.kidsActive() ? this.kidsItems.length : 0;
        var pack = this.qty > 1 || kidsCount > 0;
        this.stickyBar.classList.toggle('is-pack', pack);
        if (this.stickyTitle) {
          this.stickyTitle.textContent = pack
            ? this.qty + ' ' + ((this.qty > 1 ? this.dataset.nounMany : this.dataset.nounOne) || '') + (kidsCount ? this.t(kidsCount > 1 ? 'kidsPlusMany' : 'kidsPlus', { n: kidsCount }) : '')
            : this.stickyTitleText;
        }
        this.stickyPrice.querySelector('.sst-bb-sticky__total').textContent = formatMoney(this.summary.total, this.moneyFormat);
        var compare = this.stickyPrice.querySelector('.sst-bb-sticky__compare');
        compare.hidden = !(this.summary.compare > this.summary.total);
        compare.textContent = formatMoney(this.summary.compare, this.moneyFormat);
        var save = this.stickyPrice.querySelector('.sst-bb-sticky__save');
        save.hidden = compare.hidden;
        save.textContent = this.t('save') + formatMoney(this.summary.compare - this.summary.total, this.moneyFormat);
      }
      if (this.stickySelect && this.size) {
        var current = this.currentStyle();
        var variant = current.variants.find(function (v) { return v.options[current.sizeIndex] === this.size; }, this);
        if (variant) this.stickySelect.value = String(variant.id);
      }
    }

    rowLabel(index) {
      return (this.dataset.rowLabel || 'Print [n]').replace('[n]', index + 1);
    }

    // Desktop buy box is position: sticky; top: 20px. When it's taller than the window that pins its top
    // and hides the builder until the gallery has scrolled past. Scroll it first, then stick at its bottom.
    stickToBottom() {
      var column = this.closest('.product-single__sticky');
      if (!column || !window.ResizeObserver) return;
      var update = function () {
        if (getComputedStyle(column).position !== 'sticky') return;
        column.style.top = Math.min(20, window.innerHeight - column.offsetHeight - 20) + 'px';
      };
      new ResizeObserver(update).observe(column);
      window.addEventListener('resize', update);
      update();
    }

    setSize(size) {
      this.size = size;
      // Drop picks that don't come in the new size (rows with their own size keep theirs)
      this.picks = this.picks.map(function (index, i) {
        if (index == null || (i > 0 && this.rowSizes[i])) return index;
        return this.styleAvailable(this.styles[index]) ? index : null;
      }, this);
      this.render();
    }

    // Shopper hit the button before finishing: open what's missing and point at it
    showMissing() {
      var missing = this.picks.slice(0, this.qty).findIndex(function (p) { return p == null; });
      var kidsMissing = this.kidsMissing();
      if (missing < 0 && this.size && kidsMissing > -1) {
        if (this.kidsEdit !== kidsMissing) {
          this.kidsEdit = kidsMissing;
          this.render();
        }
        this.kidsSizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.kidsSizes.classList.remove('is-flash');
        void this.kidsSizes.offsetWidth;
        this.kidsSizes.classList.add('is-flash');
        this.warn.classList.remove('is-flash');
        void this.warn.offsetWidth;
        this.warn.classList.add('is-flash');
        return;
      }
      if (missing < 0 && this.size && kidsMissing < 0 && this.addonActive() && !this.addonPick) {
        this.addonSizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.addonSizes.classList.remove('is-flash');
        void this.addonSizes.offsetWidth;
        this.addonSizes.classList.add('is-flash');
        this.warn.classList.remove('is-flash');
        void this.warn.offsetWidth;
        this.warn.classList.add('is-flash');
        return;
      }
      var target = this.themeSizeInputs[0] || this.querySelector('[data-bb-sizes]');
      if (this.size && missing === 0 && this.lockFirst && this.qty < 2) {
        target = this.themeSizeInputs[0] || this.topPrints;
      } else if (this.size && missing > -1) {
        this.openRow = missing;
        this.render();
        target = this.rows[missing];
      }
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.warn.classList.remove('is-flash');
      void this.warn.offsetWidth;
      this.warn.classList.add('is-flash');
    }

    onClick(evt) {
      var sizeBtn = evt.target.closest('[data-bb-size]');
      if (sizeBtn && this.contains(sizeBtn)) {
        this.setSize(sizeBtn.dataset.bbSize);
        return;
      }

      if (this.kidsCard && this.kidsCard.contains(evt.target)) {
        this.onKidsClick(evt);
        return;
      }

      var addonSize = evt.target.closest('[data-bb-addon-size]');
      if (addonSize && this.addonCard && this.addonCard.contains(addonSize)) {
        if (!addonSize.disabled) {
          this.addonPick = { id: parseInt(addonSize.dataset.bbAddonSize, 10), price: parseInt(addonSize.dataset.price, 10) || 0 };
        }
        this.render();
        return;
      }

      var swatch = evt.target.closest('[data-bb-style]');
      if (swatch && !swatch.disabled) {
        var row = swatch.closest('[data-bb-row]');
        var rowIndex = parseInt(row.dataset.bbRow, 10);
        this.picks[rowIndex] = parseInt(swatch.dataset.bbStyle, 10);
        // A new print starts on the page's size again when that size is in stock
        if (this.rowSizes[rowIndex] && this.styleAvailable(this.styles[this.picks[rowIndex]], this.size)) this.rowSizes[rowIndex] = null;
        // The prints stay open so the shopper can keep trying others; tapping the row (or another one) closes them
        this.openRow = rowIndex;
        this.render();
        return;
      }

      var toggle = evt.target.closest('[data-bb-row-toggle]');
      if (toggle) {
        var index = parseInt(toggle.closest('[data-bb-row]').dataset.bbRow, 10);
        this.openRow = this.openRow === index ? -1 : index;
        this.render();
        return;
      }

      // Tapping a trunk (or an empty spot's number) in the preview opens that print's row and goes straight to it
      var slot = evt.target.closest('[data-bb-slot]');
      if (slot) {
        var slotIndex = parseInt(slot.dataset.bbSlot, 10);
        this.openRow = slotIndex;
        this.render();
        this.scrollToRow(slotIndex);
        return;
      }

      if (evt.target.closest('[data-bb-fill]')) {
        // Big packs: copy print 1 into every empty row instead of picking each one
        var first = this.picks[0];
        this.picks = this.picks.map(function (p, i) { return i < this.qty && p == null ? first : p; }, this);
        this.openRow = null;
        this.render();
        return;
      }

      var tier = evt.target.closest('[data-bb-tier]');
      if (tier) {
        var before = this.qty;
        this.qty = parseInt(tier.dataset.qty, 10);
        this.render();
        if (this.qty > 1 && this.qty !== before) this.reveal(this.field);
        return;
      }

      if (evt.target.closest('[data-bb-cta]')) {
        if (this.cta.getAttribute('aria-disabled') === 'true') {
          this.showMissing();
        } else {
          this.addToCart();
        }
      }
    }

    // Brings the open prints on screen and keeps the preview above them in view when both fit (between the
    // sticky header and the sticky Add to cart bar), so every print tapped shows in the preview without scrolling.
    // Too tall for both: the whole row + prints, with as much preview as fits. Taller than the screen: from the row.
    scrollToRow(index) {
      var header = document.getElementById('SiteHeader');
      var sticky = document.getElementById('StickyCart');
      var topInset = (header ? header.offsetHeight : 0) + 12;
      var bottomInset = (sticky ? sticky.offsetHeight : 0) + 12;
      var room = window.innerHeight - topInset - bottomInset;
      var y = window.pageYOffset;
      var rowTop = this.rows[index].getBoundingClientRect().top;
      var end = (this.panel.hidden ? this.rows[index] : this.panel).getBoundingClientRect().bottom;
      var previewTop = this.preview.getBoundingClientRect().top;
      var top;
      if (end - previewTop <= room) {
        top = previewTop - topInset;
      } else if (end - rowTop <= room) {
        top = end - window.innerHeight + bottomInset;
      } else {
        top = rowTop - topInset;
      }
      window.scrollTo({ top: Math.max(0, top + y), behavior: 'smooth' });
    }

    // A section that just opened (the kids' card switched on, or the "Pick 3 prints" box after Buy 3): scroll so
    // all of it shows between the sticky header and the sticky Add to cart bar, or from its top when it's taller
    // than that (Uki #441/#442). Again once its photos have loaded and it has grown.
    reveal(el) {
      var run = function () {
        if (!el || el.hidden) return;
        var header = document.getElementById('SiteHeader');
        var sticky = document.getElementById('StickyCart');
        var topInset = (header ? header.offsetHeight : 0) + 12;
        var bottomInset = (sticky ? sticky.offsetHeight : 0) + 12;
        var rect = el.getBoundingClientRect();
        var shift = Math.min(rect.bottom - (window.innerHeight - bottomInset), rect.top - topInset);
        if (shift > 1) window.scrollTo({ top: window.pageYOffset + shift, behavior: 'smooth' });
      };
      requestAnimationFrame(run);
      setTimeout(run, 450);
    }

    onChange(evt) {
      if (this.addonSwitch && evt.target === this.addonSwitch) {
        this.addonOn = this.addonSwitch.checked;
        this.render();
        if (this.addonOn) this.reveal(this.addonCard);
        return;
      }
      if (this.kidsSwitch && evt.target === this.kidsSwitch) {
        this.kidsOn = this.kidsSwitch.checked;
        this.render();
        if (this.kidsOn) this.reveal(this.kidsCard);
        return;
      }
      var select = evt.target.closest('[data-bb-row-size]');
      if (!select) return;
      var index = parseInt(select.closest('[data-bb-row]').dataset.bbRow, 10);
      if (index === 0) {
        // Print 1 is the page's size: go through the theme's Size circles so both stay in sync
        var radio = this.themeSizeInputs.find(function (input) { return input.value === select.value; });
        if (radio) {
          radio.click();
        } else {
          this.setSize(select.value);
        }
        return;
      }
      this.rowSizes[index] = select.value === this.size ? null : select.value;
      this.render();
    }

    renderRowSize(row, i) {
      var select = row.querySelector('[data-bb-row-size]');
      if (!select) return;
      var pick = this.picks[i];
      // Rows without a print yet still show their size (Print 1's), listed from this page's print
      var style = pick != null ? this.styles[pick] : this.currentStyle();
      select.hidden = !style || this.size === '__any__';
      if (select.hidden) return;
      var key = String(this.styles.indexOf(style));
      if (select.dataset.style !== key) {
        select.dataset.style = key;
        select.innerHTML = '';
        this.sizesOf(style).forEach(function (value) {
          var option = document.createElement('option');
          var inStock = !!this.variantFor(style, value);
          option.value = value;
          option.disabled = !inStock;
          option.textContent = inStock ? value : this.t('soldOutOption', { size: value });
          select.appendChild(option);
        }, this);
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.disabled = true;
        placeholder.textContent = this.t('sizeLabel');
        select.insertBefore(placeholder, select.firstChild);
      }
      select.value = this.sizeFor(i) || '';
    }

    render() {
      var qty = this.qty;
      var tier = this.activeTier();
      var noun = this.dataset.styleNoun || 'print';

      this.heading.textContent = qty === 1
        ? this.dataset.headingOne
        : this.dataset.headingMany.replace('[count]', qty);

      this.sizeButtons.forEach(function (btn) {
        var value = btn.dataset.bbSize;
        btn.setAttribute('aria-checked', String(value === this.size));
        // Crossed out when no print has it in stock, like the theme's own size circles
        btn.disabled = !this.styles.some(function (s) { return !!this.variantFor(s, value); }, this);
      }, this);

      this.field.hidden = qty < 2;

      // Open row: the one the shopper chose, else the first empty one (-1 = all closed)
      var open = this.openRow;
      if (open == null || open >= qty) {
        open = this.picks.slice(0, qty).findIndex(function (p) { return p == null; });
      }
      // The print being chosen is the one the preview brings forward
      this.focusRow = open;

      this.rows.forEach(function (row, i) {
        row.hidden = i >= qty;
        var pick = this.picks[i];
        var value = row.querySelector('[data-bb-row-value]');
        value.textContent = pick != null ? this.styles[pick].title : this.dataset.placeholder;
        value.classList.toggle('is-empty', pick == null);

        var isOpen = i === open;
        row.classList.toggle('is-open', isOpen);
        row.classList.toggle('is-picked', pick != null);
        row.querySelector('[data-bb-row-toggle]').setAttribute('aria-expanded', String(isOpen));
        var thumb = row.querySelector('[data-bb-row-thumb]');
        var chosen = pick != null && this.panel.querySelector('[data-bb-style="' + pick + '"] img');
        thumb.innerHTML = chosen ? '<img src="' + chosen.getAttribute('src') + '" alt="" class="' + chosen.className + '">' : '';
        this.renderRowSize(row, i);
      }, this);

      // The single swatch panel lives inside the open row
      this.panel.hidden = open < 0;
      if (open >= 0) {
        var openRow = this.rows[open];
        if (this.panel.parentNode !== openRow) openRow.appendChild(this.panel);
        this.panel.setAttribute('aria-label', openRow.querySelector('.sst-bb__row-label').textContent);
      }
      var openPick = open >= 0 ? this.picks[open] : null;
      var openSize = open >= 0 ? this.sizeFor(open) : this.size;
      this.panel.querySelectorAll('[data-bb-style]').forEach(function (swatch) {
        var index = parseInt(swatch.dataset.bbStyle, 10);
        // Prints not in stock in the row's size drop out, like sold-out prints in the Matching Products swatches
        var available = this.styleAvailable(this.styles[index], openSize);
        // Packs offer full-price prints only (the discount groups skip anything with a compare-at price)
        if (this.fullPriceOnly && this.showSavings && index !== this.currentIndex && !this.styles[index].variants.every(this.eligible, this)) available = false;
        swatch.disabled = !available;
        swatch.hidden = !available;
        swatch.setAttribute('aria-checked', String(index === openPick));
      }, this);
      if (open >= 0 && qty > 1) this.warmPrints();

      var empty = this.picks.slice(0, qty).filter(function (p) { return p == null; }).length;
      var firstPick = this.picks[0];
      this.fillBtn.hidden = empty < 2 || firstPick == null;
      if (!this.fillBtn.hidden) {
        this.fillBtn.textContent = this.t('fill', { n: empty, title: this.styles[firstPick].title });
      }

      // Kids first: their picks are checked there, and switched-on kids' trunks count in the tier prices
      this.renderKids();
      this.renderAddon();

      this.tiers.forEach(function (t) {
        // Cards price a pack of this page's print (the same per item on every card, like a shelf price); the
        // panel below totals the prints actually picked. Savings count from the original price, so sale prints
        // show their markdown and full-price packs their tier discount.
        var sum = this.uniformRows(t.qty, t.pct);
        var save = sum.compare - sum.total;
        t.el.setAttribute('aria-checked', String(t.qty === qty));
        if (this.instMin && t.el.querySelector('[data-bb-inst]')) {
          // "Llevá 2" + "3 cuotas", "3 x $70.000", "$210.000 total", "sin interés"; below the minimum the plain
          // total and "Sumá N más para 3 cuotas"
          var ok = sum.total >= this.instMin;
          // The "3 x" line stays on every card (invisible below the minimum) so the prices line up (Uki #507)
          var priceEl = t.el.querySelector('[data-bb-inst-price]');
          priceEl.textContent = '';
          var times = document.createElement('small');
          times.textContent = this.instN + ' x';
          priceEl.appendChild(times);
          priceEl.appendChild(document.createTextNode(' ' + formatMoney(ok ? Math.round(sum.total / this.instN) : sum.total, this.moneyFormat)));
          priceEl.classList.toggle('is-plain', !ok);
          t.el.querySelector('[data-bb-inst-pill]').hidden = !ok;
          t.el.querySelector('[data-bb-inst-sub]').textContent = ok
            ? this.t('instTotal', { amount: formatMoney(sum.total, this.moneyFormat) })
            : t.qty === 1 ? '\u00a0' : this.t('instTotal', { amount: '' }).trim();
          // "sin interés" only once the pack reaches the cuotas; nothing under the other cards (Uki #517)
          var noteEl = t.el.querySelector('[data-bb-inst-note]');
          noteEl.textContent = this.t('instFree');
          noteEl.hidden = !ok;
          return;
        }
        t.el.querySelector('[data-bb-each]').textContent = formatMoney(Math.round(sum.total / t.qty), this.moneyFormat);
        t.el.querySelector('[data-bb-total]').textContent = formatMoney(sum.total, this.moneyFormat);
        // Green "Save $20.97" under the price (sale prints show their markdown); the "10% OFF" pill next to "Buy 3"
        // only when the pack discount applies
        var saveEl = t.el.querySelector('[data-bb-save]');
        saveEl.hidden = save < 1;
        saveEl.textContent = this.t('save', { amount: formatMoney(save, this.moneyFormat) });
        var pctEl = t.el.querySelector('[data-bb-pct]');
        pctEl.hidden = !sum.rate || save < 1;
        pctEl.textContent = this.t('pctOff', { n: sum.rate });
        t.el.querySelector('[data-bb-ship]').hidden = !this.freeShipCents || sum.total < this.freeShipCents;
      }, this);

      this.renderCta(tier, noun);
      this.renderPreview();
      this.syncStickyBar();
    }

    // Preview layout, like a product line-up: the trunks side by side in one row, waistbands on one line, each
    // overlapping the last a little and in front of it (the print being chosen is lifted above all of them).
    // The row fills the panel's width, so the panel's height follows the count: { height (× width), spots in % }.
    previewLayout(n) {
      var padX = 0.03;
      var padTop = 0.035;
      var padBottom = 0.06;
      var step = n < 2 ? 0 : n === 2 ? 0.8 : n === 3 ? 0.75 : n === 4 ? 0.72 : 0.7;
      var slotW = (1 - 2 * padX) / (1 + (n - 1) * step);
      if (n < 2) slotW = 0.5;
      var slotH = slotW / SLOT_ASPECT;
      var height = padTop + slotH + padBottom;
      var spots = [];
      for (var i = 0; i < n; i++) {
        spots.push({
          left: (n < 2 ? (1 - slotW) / 2 : padX + i * slotW * step) * 100,
          top: (padTop / height) * 100,
          width: slotW * 100,
          height: (slotH / height) * 100,
          z: i + 1
        });
      }
      return { height: height, spots: spots };
    }

    // Panel height = width × the layout's ratio (300px at most, the row centred in it), eased between pack sizes
    sizePreview() {
      if (!this.preview || !this.previewRatio) return;
      var width = this.preview.clientWidth;
      if (!width) return;
      var height = Math.min(300, Math.round(width * this.previewRatio));
      this.preview.style.height = height + 'px';
      this.stage.style.width = Math.min(width, Math.round(height / this.previewRatio)) + 'px';
    }

    // One trunk in the preview: the untouched product photo masked to the garment's shape (the white background
    // goes, the photo keeps its full detail) and sized so the garment fills the slot, inside a wrapper that draws
    // the drop shadow; plus a grey placeholder in this page's trunk shape with the print's number while it isn't picked
    // (neighbouring placeholders alternate two greys so they don't merge where they overlap)
    createSlot(index, stage, attr) {
      var slot = { index: index, shown: false };
      slot.ghost = document.createElement('span');
      slot.ghost.className = 'sst-bb__slot-ghost';
      slot.ghostShape = document.createElement('span');
      slot.ghost.appendChild(slot.ghostShape);
      slot.trunk = document.createElement('span');
      slot.trunk.className = 'sst-bb__slot-trunk';
      slot.img = document.createElement('img');
      slot.img.crossOrigin = 'anonymous';
      slot.img.alt = '';
      slot.img.decoding = 'async';
      slot.img.addEventListener('load', function () {
        slot.trunk.classList.remove('is-swapping');
        // The placeholder stays until the picked trunk is actually on screen
        if (slot.src) slot.ghost.classList.remove('is-on');
      });
      slot.trunk.appendChild(slot.img);
      slot.add = document.createElement('span');
      slot.add.className = 'sst-bb__slot-add';
      if (index % 2) slot.ghost.classList.add('is-alt');
      // the pack's preview numbers its spots like the rows (Print 2, Print 3…); the kids' tiles keep the "+"
      if (!attr) slot.add.setAttribute('data-bb-num', index + 1);
      slot.parts = [slot.ghost, slot.trunk, slot.add];
      slot.parts.forEach(function (el) {
        el.dataset[attr || 'bbSlot'] = index;
        el.setAttribute('aria-hidden', 'true');
        el.classList.add('is-off');
        (stage || this.stage).appendChild(el);
      }, this);
      return slot;
    }

    setGhostShape(slot, url) {
      if (slot.ghostUrl === url) return;
      slot.ghostUrl = url;
      shape(url).then(function (found) {
        if (slot.ghostUrl !== url) return;
        setMask(slot.ghostShape, found && found.url);
        slot.ghost.classList.toggle('has-mask', !!found);
        if (found) fitGarment(slot.ghostShape, found.box, found.ratio, SLOT_ASPECT);
      });
    }

    // Show a print in a slot: the old trunk stays up until the new photo and its shape are ready, then a quick
    // cross-fade (photo, mask and fit switch together while it's faded out)
    showPhoto(slot, src) {
      shape(src).then(function (found) {
        if (slot.src !== src) return;
        var apply = function () {
          setMask(slot.img, found && found.url);
          fitGarment(slot.img, found ? found.box : WHOLE_PHOTO, found ? found.ratio : 1, SLOT_ASPECT);
          slot.trunk.classList.toggle('is-raw', !found);
          if (slot.img.getAttribute('src') === src) {
            slot.trunk.classList.remove('is-swapping');
          } else {
            slot.img.src = src;
          }
        };
        slot.trunk.classList.add('is-swapping');
        if (slot.img.getAttribute('src')) {
          slot.timer = setTimeout(apply, 100);
        } else {
          apply();
        }
      });
    }

    renderPreview() {
      if (!this.preview || this.qty < 2) return;
      var qty = this.qty;
      var layout = this.previewLayout(qty);
      var spots = layout.spots;
      this.previewRatio = layout.height;
      this.sizePreview();
      var names = [];
      var placeholder = this.currentStyle();
      while (this.slots.length < Math.min(qty, this.rows.length)) this.slots.push(this.createSlot(this.slots.length));

      this.slots.forEach(function (slot, i) {
        var spot = spots[i];
        if (!spot) {
          slot.shown = false;
          slot.parts.forEach(function (el) { el.classList.add('is-off'); });
          return;
        }
        var pick = this.picks[i];
        var style = pick != null ? this.styles[pick] : null;
        var empty = !style || !style.image;
        names.push(style ? style.title : this.t('notChosen', { row: this.rowLabel(i) }));

        // The print being chosen comes to the front with a slight lift; otherwise the newest print is on top
        var focus = i === this.focusRow;
        slot.ghost.style.zIndex = focus ? 10 : spot.z;
        slot.trunk.style.zIndex = focus ? 10 : spot.z;
        slot.add.style.zIndex = 20;
        slot.ghost.classList.toggle('is-focus', focus);
        slot.trunk.classList.toggle('is-focus', focus);
        slot.trunk.classList.toggle('is-empty', empty);
        slot.add.classList.toggle('is-empty', empty);
        if (empty) slot.ghost.classList.add('is-on');
        // The number sits in the middle of the part of the trunk that shows (Uki #437): a neighbour drawn in
        // front of it covers one edge
        var zOf = function (j) { return j === this.focusRow ? 10 : spots[j].z; }.bind(this);
        var from = spot.left;
        var to = spot.left + spot.width;
        if (spots[i - 1] && i - 1 < qty && zOf(i - 1) > zOf(i)) from = Math.max(from, spots[i - 1].left + spots[i - 1].width);
        if (spots[i + 1] && i + 1 < qty && zOf(i + 1) > zOf(i)) to = Math.min(to, spots[i + 1].left);
        if (to - from < spot.width * 0.4) {
          from = spot.left;
          to = spot.left + spot.width;
        }
        slot.parts.forEach(function (el) {
          var add = el === slot.add;
          el.style.left = (add ? from : spot.left) + '%';
          el.style.top = spot.top + '%';
          el.style.width = (add ? to - from : spot.width) + '%';
          el.style.height = spot.height + '%';
        });

        // Newly shown trunks appear in place (no slide from where they last were), then fade in
        if (!slot.shown) {
          void slot.trunk.offsetWidth;
          slot.shown = true;
        }
        slot.parts.forEach(function (el) { el.classList.remove('is-off'); });

        var src = empty ? '' : style.image;
        if (slot.src !== src) {
          slot.src = src;
          clearTimeout(slot.timer);
          if (src) {
            this.showPhoto(slot, src);
          } else {
            slot.img.removeAttribute('src');
          }
        }
        this.setGhostShape(slot, (placeholder && placeholder.image) || '');
      }, this);

      this.preview.setAttribute('aria-label', this.t('preview', { list: names.join(', ') }));
    }

    // The kids' tile, a family set: each kids' trunk next to the big trunk in the same print, the kids' one at
    // 2/3 size with the bottoms on one line, so it's clear what goes together. Several sets sit side by side
    // (each kid's trunk tucked a little over its big one to save room; `tight` tucks it further, for the small
    // header tile). Same { height, spots } as previewLayout.
    kidsLayout(n, tight) {
      var padX = tight ? 0.03 : 0.04;
      var padTop = 0.04;
      var padBottom = 0.06;
      var kid = 0.66;
      var inner = tight ? -0.22 : n < 2 ? 0.04 : -0.1;
      var between = 0.1;
      var w = (1 - 2 * padX) / (n * (1 + inner + kid) + (n - 1) * between);
      var h = w / SLOT_ASPECT;
      var height = padTop + h + padBottom;
      var spots = [];
      var x = padX;
      for (var i = 0; i < n; i++) {
        spots.push({ left: x * 100, top: (padTop / height) * 100, width: w * 100, height: (h / height) * 100, z: 2 * i + 1 });
        x += w * (1 + inner);
        spots.push({ left: x * 100, top: ((padTop + h * (1 - kid)) / height) * 100, width: w * kid * 100, height: (h * kid / height) * 100, z: 2 * i + 2 });
        x += w * (kid + between);
      }
      return { height: height, spots: spots };
    }

    // A set tile: panel + stage + its slots; height = width × the layout's ratio (cap px at most)
    makeTile(panel, stageSelector, attr, cap, tight) {
      if (!panel) return null;
      var tile = { panel: panel, stage: panel.querySelector(stageSelector), slots: [], attr: attr, cap: cap, ratio: 0, tight: !!tight };
      if (window.ResizeObserver) new ResizeObserver(this.sizeTile.bind(this, tile)).observe(panel);
      return tile;
    }

    sizeTile(tile) {
      if (!tile || !tile.ratio) return;
      var width = tile.panel.clientWidth;
      if (!width) return;
      var height = Math.min(tile.cap, Math.round(width * tile.ratio));
      tile.panel.style.height = height + 'px';
      tile.stage.style.width = Math.min(width, Math.round(height / tile.ratio)) + 'px';
    }

    // Lays the sets (kids' print indexes) out in a tile: per set the big trunk, then the kids' trunk
    fillTile(tile, picks, focusSet) {
      if (!tile) return [];
      var layout = this.kidsLayout(picks.length, tile.tight);
      tile.ratio = layout.height;
      this.sizeTile(tile);
      var entries = [];
      var names = [];
      picks.forEach(function (pick, k) {
        // The card's trunk (kids', or dad's on kids' pages) and the pack's own trunk in the same print
        var mate = this.kids[pick];
        var title = titleKey(mate.title);
        var own = this.styles.find(function (st) { return titleKey(st.title) === title; });
        var big = this.kidsDad ? mate : own;
        var small = this.kidsDad ? own : mate;
        names.push(mate.title);
        entries.push({ spot: layout.spots[2 * k], src: (big && big.image) || '', focus: this.kidsDad && k === focusSet });
        entries.push({ spot: layout.spots[2 * k + 1], src: (small && small.image) || '', focus: !this.kidsDad && k === focusSet });
      }, this);
      while (tile.slots.length < entries.length) tile.slots.push(this.createSlot(tile.slots.length, tile.stage, tile.attr));
      tile.slots.forEach(function (slot, i) {
        var entry = entries[i];
        if (!entry) {
          slot.shown = false;
          slot.parts.forEach(function (el) { el.classList.add('is-off'); });
          return;
        }
        var spot = entry.spot;
        slot.ghost.style.zIndex = entry.focus ? 10 : spot.z;
        slot.trunk.style.zIndex = entry.focus ? 10 : spot.z;
        slot.add.style.zIndex = 20;
        slot.trunk.classList.toggle('is-focus', entry.focus);
        slot.parts.forEach(function (el) {
          el.style.left = spot.left + '%';
          el.style.top = spot.top + '%';
          el.style.width = spot.width + '%';
          el.style.height = spot.height + '%';
        });
        if (!slot.shown) {
          void slot.trunk.offsetWidth;
          slot.shown = true;
        }
        slot.parts.forEach(function (el) { el.classList.remove('is-off'); });
        if (slot.src !== entry.src) {
          slot.src = entry.src;
          clearTimeout(slot.timer);
          if (entry.src) this.showPhoto(slot, entry.src);
        }
      }, this);
      return names;
    }

    // Open: every kids' trunk switched on as a set (the one being edited lifted when there are several);
    // closed: the mini tile shows the set for the first matching print
    renderKidsPreview() {
      var picks = this.kidsItems.map(function (item) { return item.pick; });
      this.fillTile(this.kidsMiniTile, [this.kidsCur().pick], -1);
      if (!this.kidsOn) return;
      var names = this.fillTile(this.kidsTile, picks, picks.length > 1 ? this.kidsEdit : -1);
      this.kidsPreview.setAttribute('aria-label', this.t('kidsPreview', { list: names.join(', ') }));
    }

    // Complete the look: the kids' trunks in the prints picked so far (in pick order, once each). Hidden when none
    // of them has a kids version; the page's old "Kids matching swim trunks" link hides while the card shows.
    renderKids() {
      if (!this.kidsCard) return;
      var matches = [];
      this.picks.slice(0, this.qty).forEach(function (pick) {
        if (pick == null) return;
        var title = titleKey(this.styles[pick].title);
        var kid = this.kids.findIndex(function (k) {
          return titleKey(k.title) === title && k.variants.some(function (v) { return v.available; });
        });
        if (kid > -1 && matches.indexOf(kid) < 0) matches.push(kid);
      }, this);
      this.kidsMatches = matches;
      this.kidsCard.hidden = !matches.length;
      var holder = this.closest('.product-single__meta') || this.closest('.shopify-section');
      if (holder) holder.classList.toggle('sst-bb-kids-on', matches.length > 0);
      if (!matches.length) return;
      // Extra kids' trunks only live in packs of 2+ and in prints still matching the pack
      var extras = this.qty < 2 ? [] : this.kidsItems.slice(1).filter(function (item) { return matches.indexOf(item.pick) > -1; });
      this.kidsItems = this.kidsItems.slice(0, 1).concat(extras);
      this.kidsItems.forEach(function (item) {
        if (matches.indexOf(item.pick) < 0) item.pick = matches[0];
        if (item.size && !this.variantFor(this.kids[item.pick], item.size)) item.size = null;
      }, this);
      if (this.kidsEdit >= this.kidsItems.length) this.kidsEdit = this.kidsItems.length - 1;
      var cur = this.kidsCur();
      var kid = this.kids[cur.pick];

      this.kidsSwitch.checked = this.kidsOn;
      this.kidsCard.classList.toggle('is-on', this.kidsOn);
      this.kidsBody.hidden = !this.kidsOn;

      // Closed: "From $X" across the matching prints; open: the chosen print's price (full price, no pack discount)
      var shown = this.kidsItemVariant(this.kidsEdit);
      var prices = [];
      matches.forEach(function (k) {
        this.kids[k].variants.forEach(function (v) { if (v.available && prices.indexOf(v.price) < 0) prices.push(v.price); });
      }, this);
      var lowest = Math.min.apply(null, prices);
      this.kidsPrice.innerHTML = '';
      this.kidsPrice.appendChild(document.createTextNode(this.kidsOn || prices.length < 2
        ? formatMoney(this.kidsOn ? shown.price : lowest, this.moneyFormat)
        : this.t('kidsFrom', { price: formatMoney(lowest, this.moneyFormat) })));
      if (this.kidsOn && shown.compare && shown.compare > shown.price) {
        var was = document.createElement('s');
        was.textContent = formatMoney(shown.compare, this.moneyFormat);
        this.kidsPrice.appendChild(was);
      }

      // Print circles: the same swatches as the pack's prints
      var key = matches.join(',');
      if (this.kidsPrints.dataset.key !== key) {
        this.kidsPrints.dataset.key = key;
        this.kidsPrints.innerHTML = '';
        matches.forEach(function (k) {
          var kidStyle = this.kids[k];
          var adult = this.styles.findIndex(function (st) { return titleKey(st.title) === titleKey(kidStyle.title); });
          var swatchImg = adult > -1 && this.panel.querySelector('[data-bb-style="' + adult + '"] img');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sst-bb__kid';
          btn.setAttribute('role', 'radio');
          btn.dataset.bbKid = k;
          btn.setAttribute('aria-label', kidStyle.title);
          btn.title = kidStyle.title;
          var circle = document.createElement('span');
          circle.className = 'sst-bb__swatch-inner';
          var img = document.createElement('img');
          img.alt = '';
          img.src = swatchImg ? swatchImg.getAttribute('src') : withWidth(kidStyle.image, 200);
          if (swatchImg) img.className = swatchImg.className;
          else if (this.dataset.leg === 'true') {
            // no adult circle to copy: zoom on the kids' trunk's leg like the other circles
            img.className = 'sst-bb__leg';
            img.src = withWidth(kidStyle.image, 540);
          }
          circle.appendChild(img);
          var name = document.createElement('span');
          name.className = 'sst-bb__kid-name';
          name.textContent = kidStyle.title;
          btn.appendChild(circle);
          btn.appendChild(name);
          this.kidsPrints.appendChild(btn);
        }, this);
      }
      this.kidsPrints.querySelectorAll('[data-bb-kid]').forEach(function (btn) {
        btn.setAttribute('aria-checked', String(parseInt(btn.dataset.bbKid, 10) === cur.pick));
      }, this);

      // Kids' sizes of the chosen print; sold-out ones crossed out
      var sizeKey = String(cur.pick);
      if (this.kidsSizes.dataset.key !== sizeKey) {
        this.kidsSizes.dataset.key = sizeKey;
        this.kidsSizes.innerHTML = '';
        this.sizesOf(kid).forEach(function (value) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sst-bb__kid-size';
          btn.setAttribute('role', 'radio');
          btn.dataset.bbKidSize = value;
          btn.textContent = value;
          btn.disabled = !this.variantFor(kid, value);
          this.kidsSizes.appendChild(btn);
        }, this);
        // Even rows of at most 6 (Uki #444): kids' 2–14 = 5 + 5 instead of 9 and a lone 14
        var count = this.kidsSizes.children.length;
        this.kidsSizes.style.setProperty('--bb-size-cols', Math.ceil(count / Math.ceil(count / 6)) || 1);
      }
      this.kidsSizes.querySelectorAll('[data-bb-kid-size]').forEach(function (btn) {
        btn.setAttribute('aria-checked', String(btn.dataset.bbKidSize === cur.size));
      }, this);

      // Two or more kids' trunks: a short list to switch between them (and remove one)
      this.kidsList.hidden = this.kidsItems.length < 2;
      this.kidsList.innerHTML = '';
      if (this.kidsItems.length > 1) {
        this.kidsItems.forEach(function (item, i) {
          var itemKid = this.kids[item.pick];
          var label = this.t('kidsRow', { n: i + 1 });
          var row = document.createElement('div');
          row.className = 'sst-bb__kids-item' + (i === this.kidsEdit ? ' is-active' : '');
          var pickBtn = document.createElement('button');
          pickBtn.type = 'button';
          pickBtn.className = 'sst-bb__kids-item-pick';
          pickBtn.dataset.bbKidsItem = i;
          pickBtn.setAttribute('aria-pressed', String(i === this.kidsEdit));
          var strong = document.createElement('strong');
          strong.textContent = label;
          pickBtn.appendChild(strong);
          pickBtn.appendChild(document.createTextNode(' · ' + itemKid.title + ' · ' + (item.size || this.t('kidsNoSize'))));
          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'sst-bb__kids-item-remove';
          remove.dataset.bbKidsRemove = i;
          remove.setAttribute('aria-label', this.t('kidsRemove', { row: label }));
          remove.textContent = '×';
          row.appendChild(pickBtn);
          row.appendChild(remove);
          this.kidsList.appendChild(row);
        }, this);
      }
      // "Add another" only in packs of 2+, while a matching print has no kids' trunk yet
      this.kidsMore.hidden = this.qty < 2 || this.kidsUnusedPrint() == null;
      this.renderKidsPreview();
    }

    kidsCur() {
      return this.kidsItems[this.kidsEdit];
    }

    // First matching kids' print no kids' trunk has yet (undefined = all taken)
    kidsUnusedPrint() {
      return (this.kidsMatches || []).find(function (k) {
        return !this.kidsItems.some(function (item) { return item.pick === k; });
      }, this);
    }

    // A kids' trunk not sized yet stands in as its print's first size in stock
    kidsItemVariant(i) {
      return this.kidsVariantAt(i) || this.kids[this.kidsItems[i].pick].variants.find(function (v) { return v.available; });
    }

    kidsVariantAt(i) {
      var item = this.kidsItems[i];
      var kid = item && this.kids[item.pick];
      return kid && item.size ? this.variantFor(kid, item.size) : null;
    }

    // First kids' trunk still without a size (-1 = all set)
    kidsMissing() {
      if (!this.kidsActive()) return -1;
      return this.kidsItems.findIndex(function (item, i) { return !this.kidsVariantAt(i); }, this);
    }

    kidsVariant() {
      return this.kidsVariantAt(this.kidsEdit);
    }

    renderAddon() {
      if (!this.addonCard) return;
      this.addonSwitch.checked = this.addonOn;
      this.addonCard.classList.toggle('is-on', this.addonOn);
      this.addonBody.hidden = !this.addonOn;
      this.addonSizes.querySelectorAll('[data-bb-addon-size]').forEach(function (btn) {
        btn.setAttribute('aria-checked', String(!!this.addonPick && parseInt(btn.dataset.bbAddonSize, 10) === this.addonPick.id));
      }, this);
    }

    // The Complete the look product counts while its switch is on
    addonActive() {
      return !!(this.addonCard && this.addonOn);
    }

    // The kids' trunk counts while the switch is on and the card shows (some prints have no kids version)
    kidsActive() {
      return !!(this.kidsCard && !this.kidsCard.hidden && this.kidsOn);
    }

    onKidsClick(evt) {
      var kidSlot = evt.target.closest('[data-bb-kids-slot]');
      if (kidSlot) {
        this.kidsEdit = Math.floor(parseInt(kidSlot.dataset.bbKidsSlot, 10) / 2);
        this.render();
        return;
      }
      var printBtn = evt.target.closest('[data-bb-kid]');
      if (printBtn) {
        this.kidsCur().pick = parseInt(printBtn.dataset.bbKid, 10);
        this.render();
        return;
      }
      var sizeBtn = evt.target.closest('[data-bb-kid-size]');
      if (sizeBtn && !sizeBtn.disabled) {
        this.kidsCur().size = sizeBtn.dataset.bbKidSize;
        this.render();
        return;
      }
      var itemBtn = evt.target.closest('[data-bb-kids-item]');
      if (itemBtn) {
        this.kidsEdit = parseInt(itemBtn.dataset.bbKidsItem, 10);
        this.render();
        return;
      }
      var removeBtn = evt.target.closest('[data-bb-kids-remove]');
      if (removeBtn) {
        this.kidsItems.splice(parseInt(removeBtn.dataset.bbKidsRemove, 10), 1);
        this.kidsEdit = Math.min(this.kidsEdit, this.kidsItems.length - 1);
        this.render();
        return;
      }
      // Another kids' trunk: starts on a matching print no kids' trunk has yet, size to pick
      if (evt.target.closest('[data-bb-kids-more]')) {
        var next = this.kidsUnusedPrint();
        if (next == null) return;
        this.kidsItems.push({ pick: next, size: null });
        this.kidsEdit = this.kidsItems.length - 1;
        this.render();
      }
    }

    renderSummary(sum) {
      // Switched-on kids' (or dad's) trunks join the total at full price: the pack discount is for the pack only
      var kidsOn = this.kidsActive();
      var kidsCount = kidsOn ? this.kidsItems.length : 0;
      if (kidsOn) {
        sum = { price: sum.price, compare: sum.compare, total: sum.total, missing: sum.missing };
        this.kidsItems.forEach(function (item, i) {
          var kv = this.kidsItemVariant(i);
          sum.price += kv.price;
          sum.compare += Math.max(kv.compare || 0, kv.price);
          sum.total += kv.price;
        }, this);
      }
      // The Complete the look product joins at full price too, once its size is chosen
      var addon = this.addonActive() ? this.addonPick : null;
      if (addon) {
        sum = { price: sum.price + addon.price, compare: sum.compare + addon.price, total: sum.total + addon.price, missing: sum.missing };
      }
      this.summary = sum;
      var noun = this.qty === 1 ? this.dataset.nounOne : this.dataset.nounMany;
      this.sumLabel.textContent = this.t('bundle') + ' · ' + this.qty + ' ' + (noun || '') + (kidsCount ? this.t(kidsCount > 1 ? 'kidsPlusMany' : 'kidsPlus', { n: kidsCount }) : '') +
        (addon ? this.t('addonPlus', { noun: this.addonCard.dataset.noun }) : '');
      this.ctaPrice.textContent = formatMoney(sum.total, this.moneyFormat);
      var saves = sum.compare > sum.total;
      this.ctaCompare.hidden = !saves;
      this.ctaCompare.textContent = formatMoney(sum.compare, this.moneyFormat);
      this.sumSave.hidden = !saves;
      this.sumSave.textContent = this.t('youSave') + formatMoney(sum.compare - sum.total, this.moneyFormat);
      // Free shipping nudge (shop-country visitors only): two trunks land just under the threshold, so it
      // asks for one more; at the threshold it confirms
      if (this.shipNudge) {
        var items = this.qty + kidsCount + (addon ? 1 : 0);
        var next = items ? sum.total / items : 0;
        var msg = '';
        if (this.freeShipCents) {
          if (sum.total >= this.freeShipCents) msg = this.t('shipFree');
          else if (sum.total + next >= this.freeShipCents) msg = this.t('shipAddOne', { noun: this.dataset.nounOne || '' });
          else msg = this.t('shipOver', { amount: formatMoney(this.freeShipCents, this.moneyFormat) });
        }
        this.shipNudge.hidden = !msg;
        this.shipNudge.textContent = msg;
        this.shipNudge.classList.toggle('is-free', !!this.freeShipCents && sum.total >= this.freeShipCents);
      }
    }

    renderCta(tier, noun) {
      this.renderSummary(this.priceRows(this.qty, tier.pct, true));
      var sum = this.priceRows(this.qty, tier.pct, false);
      var firstMissing = this.picks.slice(0, this.qty).findIndex(function (p) { return p == null; });

      if (this.ctaNote) this.ctaNote.hidden = true;
      if (this.ctaSub) this.ctaSub.hidden = true;
      this.cta.setAttribute('aria-disabled', 'true');
      this.warn.hidden = false;

      if (!this.size) {
        this.ctaText.textContent = this.t('selectSize');
        this.warn.textContent = this.t('needSize');
        return;
      }

      if (this.lockFirst && this.picks[0] == null) {
        var current = this.styles.find(function (st) { return st.id === this.data.currentId; }, this);
        var anySize = current.variants.some(function (v) { return v.available; });
        this.ctaText.textContent = anySize ? this.t('soldOutIn', { size: this.size }) : this.t('soldOut');
        this.warn.textContent = this.t(anySize ? 'soldOutSizeMsg' : 'soldOutMsg', { title: current.title, size: this.size });
        return;
      }

      if (sum.missing) {
        this.ctaText.textContent = this.t(sum.missing === 1 ? 'pickMore' : 'pickMoreMany', { n: sum.missing, noun: noun });
        this.warn.textContent = this.t(sum.missing > 1 ? 'needPrintMany' : 'needPrint', { row: this.rowLabel(firstMissing), n: sum.missing, noun: noun });
        return;
      }

      var kidsMissing = this.kidsMissing();
      if (kidsMissing > -1) {
        this.ctaText.textContent = this.t('kidsChooseSize');
        this.warn.textContent = this.kidsItems.length > 1
          ? this.t('kidsNeedSizeRow', { row: this.t('kidsRow', { n: kidsMissing + 1 }) })
          : this.t('kidsNeedSize');
        return;
      }

      if (this.addonActive() && !this.addonPick) {
        this.ctaText.textContent = this.t('addonChooseSize', { noun: this.addonCard.dataset.noun });
        this.warn.textContent = this.t('addonNeedSize', { item: this.addonCard.dataset.item });
        return;
      }

      this.warn.hidden = true;
      this.cta.setAttribute('aria-disabled', 'false');
      // The total on the button, and under it what that is (Uki #424, 2026-10-27): "ADD TO CART — $187.00",
      // "4 swim trunks · $46.75 each · Save $32.96" (one trunk alone needs no line)
      this.ctaText.textContent = this.dataset.addOne + ' — ' + formatMoney(this.summary.total, this.moneyFormat);
      if (this.ctaNote) this.ctaNote.hidden = false;
      if (this.ctaSub) {
        var kidsCount = this.kidsActive() ? this.kidsItems.length : 0;
        var addon = this.addonActive() ? this.addonPick : null;
        var parts = [];
        if (this.qty > 1 || kidsCount || addon) {
          parts.push(this.qty + ' ' + ((this.qty === 1 ? this.dataset.nounOne : this.dataset.nounMany) || '') +
            (kidsCount ? this.t(kidsCount > 1 ? 'kidsPlusMany' : 'kidsPlus', { n: kidsCount }) : '') +
            (addon ? this.t('addonPlus', { noun: this.addonCard.dataset.noun }) : ''));
          if (this.qty > 1) parts.push(formatMoney(Math.round(sum.total / this.qty), this.moneyFormat) + ' ' + this.t('each'));
          if (this.summary.compare > this.summary.total) {
            parts.push(this.t('save', { amount: formatMoney(this.summary.compare - this.summary.total, this.moneyFormat) }));
          }
        }
        this.ctaSub.textContent = parts.join(' · ');
        this.ctaSub.hidden = !parts.length;
      }
    }

    addToCart() {
      if (this.cta.getAttribute('aria-disabled') === 'true' || this.loading) return;

      var counts = {};
      this.picks.slice(0, this.qty).forEach(function (index, i) {
        var variant = this.variantFor(this.styles[index], this.sizeFor(i));
        counts[variant.id] = (counts[variant.id] || 0) + 1;
      }, this);

      // The matching kids' trunk, when switched on, goes in with the pack
      if (this.kidsActive()) {
        this.kidsItems.forEach(function (item, i) {
          var kv = this.kidsVariantAt(i);
          if (kv) counts[kv.id] = (counts[kv.id] || 0) + 1;
        }, this);
      }

      // The Complete the look product, when switched on, goes in at full price
      if (this.addonActive() && this.addonPick) {
        counts[this.addonPick.id] = (counts[this.addonPick.id] || 0) + 1;
      }

      // No line properties: UpCart's drawer prints them, and they'd split lines from normal adds
      var items = Object.keys(counts).map(function (id) {
        return { id: parseInt(id, 10), quantity: counts[id] };
      });

      this.loading = true;
      this.cta.classList.add('btn--loading');
      this.error.hidden = true;

      var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok || body.status) throw body;
            return body;
          });
        })
        .then(function (body) {
          return this.tagAbTest()
            .then(function () { return this.applyTierCode(); }.bind(this))
            .then(function (code) { this.appliedCode = code || null; return body; }.bind(this));
        }.bind(this))
        .then(function (body) {
          if (window.theme && theme.settings && theme.settings.cartType === 'page') {
            window.location = theme.routes.cartPage;
            return;
          }
          var added = body.items ? body.items[0] : body;
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: added, addToCartBtn: this.cta }
          }));
          if (this.appliedCode) this.recheckTierCode(this.appliedCode);
        }.bind(this))
        .catch(function (err) {
          this.error.textContent = (err && (err.description || err.message)) || this.t('error');
          this.error.hidden = false;
        }.bind(this))
        .finally(function () {
          this.loading = false;
          this.cta.classList.remove('btn--loading');
        }.bind(this));
    }

    // The pack price is a discount code (no automatic discount), so items added anywhere else stay at full
    // price. Pack codes never combine with anything, so the cart holds exactly one: this pack's group code
    // (counting a still-valid code of the same group as items already there), unless another group's
    // valid code is a bigger pack. Any non-pack code is replaced.
    // A/B test: the order remembers which arm's page built the bundle (cart attributes, shown on the order
    // as Additional details)
    tagAbTest() {
      if (!this.dataset.ab) return Promise.resolve();
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { bundle_test: this.dataset.ab, bundle_size: String(this.qty) } })
      }).catch(function () {});
    }

    applyTierCode() {
      var eligibleCount = this.picks.slice(0, this.qty).filter(function (pick, i) {
        var variant = this.rowVariant(i);
        return variant && this.eligible(variant);
      }, this).length;
      var family = this.tiers.filter(function (t) { return t.code; });
      if (!family.length) return Promise.resolve();
      var packCode = /^PACK(\d+)(-[A-Z]+)?$/;
      var suffix = (family[0].code.toUpperCase().match(packCode) || [])[2] || '';
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      return fetch(root + 'cart.js', { headers: headers })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var sameGroup = 0;
          var otherBest = null;
          (cart.discount_codes || []).forEach(function (d) {
            var m = String(d.code).toUpperCase().match(packCode);
            if (!m || !d.applicable) return;
            var qty = parseInt(m[1], 10);
            if ((m[2] || '') === suffix) {
              sameGroup = Math.max(sameGroup, qty);
            } else if (!otherBest || qty > otherBest.qty) {
              otherBest = { code: d.code, qty: qty };
            }
          });
          var count = eligibleCount + sameGroup;
          var tier = family.reduce(function (best, t) {
            return t.qty <= count && (!best || t.qty > best.qty) ? t : best;
          }, null);
          if (!tier || (otherBest && otherBest.qty > tier.qty)) return;
          var current = (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
          if (current.length === 1 && current[0] === tier.code.toUpperCase()) return tier.code;
          return fetch(root + 'cart/update.js', { method: 'POST', headers: headers, body: JSON.stringify({ discount: tier.code }) })
            .then(function () { return tier.code; });
        })
        .catch(function () {});
    }

    // Another app writing to the cart at the same moment (UpCart's free gift, Redo) can drop the pack code, so the
    // pack shows full price. Once the drawer is open, check the cart still has it and put it back if it's gone.
    recheckTierCode(code) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      setTimeout(function () {
        fetch(root + 'cart.js', { headers: headers })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            var codes = (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
            // Still there, cart emptied, or another pack code took its place on purpose (a bigger pack): leave it
            if (!cart.item_count || codes.indexOf(code.toUpperCase()) !== -1) return;
            if (codes.some(function (c) { return /^PACK\d/.test(c); })) return;
            return fetch(root + 'cart/update.js', { method: 'POST', headers: headers, body: JSON.stringify({ discount: code }) })
              .then(function () {
                if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
              });
          })
          .catch(function () {});
      }, 2500);
    }
  }

  customElements.define('sst-bundle-builder', SstBundleBuilder);
})();
